<div class="profile responsive-page-container">
  <div class="profile-head">
    @if (isExpert) {
      <a mat-flat-button color="primary" href="/expert-directory"
        >Expert Directory</a
        >
      }
      @if (isContributor) {
        <a
          mat-flat-button
          color="primary"
          href="/directory?tab=contributors"
          >KX Contributors</a
          >
        }
        @if (isDrupalUser) {
          <a
            mat-flat-button
            color="primary"
            href="/directory?tab=kx-team"
            >KX Team</a
            >
          }
          <h1>{{ profile.fullname }}</h1>
          <h2
      [innerHTML]="
        expertDoc.fields ? expertDoc.fields.position_title : profile.jobTitle
      "
          ></h2>
        </div>

        <div class="profile-main-info">
          <div class="image">
            @if (profile.photoURL) {
              <img
                src="{{ profile.photoURL }}"
                alt="{{ profile.fullname }}\'s Profile Photo"
                /><br />
              } @else {
                <img
          src="https://opic.osu.edu/{{
            profile.id ? profile.id : 'brutus.1'
          }}?width=1024"
                  alt="{{ profile.fullname }}\'s Profile Photo"
                  /><br />
                }
              </div>

              <div class="contact-items">
                @if (profile.email) {
                  <div class="contact-item">
                    <div class="icon">
                      <img
                        src="https://contentfilehosting.s3.amazonaws.com/Asset%2011683546624462.svg"
                        alt="mail icon"
                        />
                    </div>
                    <div class="text">
                      <div class="label">Email</div>
                      <a href="mailto:{{ profile.email }}">{{ profile.email }}</a>
                    </div>
                  </div>
                }
                @if (profile.phone) {
                  <div class="contact-item">
                    <div class="icon">
                      <img
                        src="https://contentfilehosting.s3.amazonaws.com/Group%201735.svg"
                        alt="phone icon"
                        />
                    </div>
                    <div class="text">
                      <div class="label">Phone</div>
                      <a href="tel:{{ profile.phone }}">{{ profile.phone }}</a>
                    </div>
                  </div>
                }
                @if (profile.address) {
                  <div class="contact-item">
                    <div class="icon">
                      <img
                        src="https://contentfilehosting.s3.amazonaws.com/Asset%2031683546620343.svg"
                        alt="address icon"
                        />
                    </div>
                    <div class="text">
                      <div class="label">Address</div>
                      <a href="{{ profile.buildingURL }}"
                        >{{ profile.address.street1 }}, {{ profile.address.city }}
                        {{ profile.address.state }} {{ profile.address.zip }}</a
                        >
                      </div>
                    </div>
                  }
                  @if (expertDoc.fields) {
                    <div class="contact-item">
                      <div class="icon">
                        <img
                          src="https://contentfilehosting.s3.amazonaws.com/Department.svg"
                          alt="department icon"
                          />
                      </div>
                      <div class="text">
                        <div class="label">Department</div>
                        <a
                          [href]="getExpertDepartmentURL(expertDoc.fields.department)"
                          [innerHTML]="getExpertDepartmentName(expertDoc.fields.department)"
                        ></a>
                      </div>
                    </div>
                  }
                  @if (profile.link) {
                    <div class="contact-item">
                      <div class="icon">
                        <img
                          src="https://contentfilehosting.s3.amazonaws.com/Group%202307.svg"
                          alt="link icon"
                          />
                      </div>
                      <div class="text">
                        <div class="label">Links</div>
                        <a href="{{ profile.link }}">{{ profile.link }}</a>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <br /><br />
              @if (profile.description) {
                <div
                  [innerHTML]="profile.description"
                  class="desc"
                ></div>
              }
              @if (expertDoc.fields && expertDoc.fields.keywords) {
                <div class="overview">
                  <h3>Overview</h3>
                  <ul>
                    @for (keyword of expertDoc.fields.keywords; track keyword) {
                      <li
                        [innerHTML]="keyword"
                      ></li>
                    }
                  </ul>
                </div>
              }
              @if (isContributor) {
                <h2></h2>
              }
            </div>
            @if (isContributor) {
              <content-list
                type="image-slider"
                [content]="content"
                head="Contributed Content"
              ></content-list>
            }
            <br /><br /><br />
